import React, { useState, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { CardView, TravellerDetailsWrap, TrainIcon, AddTravellerWrapper, Link, PassengerDetailsWrapper, EditButton } from '../../Style';
import { GenericP, FlexDiv, AngleArrow } from 'common/Styles';
import TravellersForm from '../TravellersForm/TravellersForm';
import { setPassesngerData } from '../../../redux/actions/trainActionDispatcher';
import { passengerDetailForm, cardViewMobileProps } from '../../config';
import DisplayContext, { Devices } from 'UtilityComponents/displayContext';

function PassengerDetails() {
	const dispatch = useDispatch();
	const passengerDetails = useSelector((state) => state.train.passengerDetails || []);
	const [showForm, setShowForm] = useState(false);
	const [formData, setFormData] = useState({});
	const [isEditMode, setIsEditMode] = useState(false);
	const [editableIndex, setEditableIndex] = useState(-1);

	const displayName = useContext(DisplayContext).isMobile;
	const isMobile = displayName == Devices.mobile;

	const addNewPassenger = (passngerData) => {
		const data = [...passengerDetails];
		if (!isEditMode) {
			data.push(passngerData);
		} else {
			data.splice(editableIndex, 1, passngerData );
			setEditableIndex(-1);
		}
		dispatch(setPassesngerData(data));
		setShowForm(false);
		setIsEditMode(false);
		setFormData({});
	};

	const addTraveller = () => {
		setShowForm(true);
		setFormData({ ...passengerDetailForm });
	};

	const deletePassenger = (index) => () => {
		const data = [...passengerDetails];
		data.splice(index, 1);
		dispatch(setPassesngerData(data));
	};

	const editPassengerDetails = (data, index) => () => {
		setShowForm(true);
		setFormData(data);
		setIsEditMode(true);
		setEditableIndex(index);
	};

	const closeForm = () => {
		setShowForm(false);
	};

	const detailView = (index, passenger) => {
		const { name = '', emailId = '', age = '', gender = '', nationality = '',
			govtIdType = '', govtIdNo = '', berthPref = '', meal = '' } = passenger;
		return (
			<TravellerDetailsWrap
				justify='space-between'
				align='baseline'
				bottom_M='10'
				bdrRad='6px'>
				<FlexDiv $width='180px'>
					<GenericP f_weight='900' color='#000' right_M='8'>{`${index + 1}.`}</GenericP>
					<div>
						<GenericP f_weight='900' color='#000' bottom_M='2'>{name}</GenericP>
						<GenericP bottom_M='8' fsize='12px'>{emailId}</GenericP>
						{govtIdNo && <GenericP fsize='12px' f_weight='900'>{`${govtIdType.name}: ${govtIdNo}`}</GenericP>}
					</div>
				</FlexDiv>
				<GenericP f_weight='900' color='#000'>{`${age}, ${gender.name}, ${nationality}`}</GenericP>
				<GenericP fsize='12px'>{`${berthPref.name}, ${meal.name} food`}</GenericP>
				<Link onClick={editPassengerDetails(passenger, index)}>EDIT</Link>
				<TrainIcon icon='delete' onClick={deletePassenger(index)} />
			</TravellerDetailsWrap>
		);
	};

	const mobileDetailsView = (index, passenger) => {
		const { name = '', emailId = '', age = '', gender = '', nationality = '',
			govtIdType = '', govtIdNo = '', berthPref = '', meal = '' } = passenger;
		return (
			<TravellerDetailsWrap
				justify='space-between'
				align='baseline'
				bottom_M='10'
				bdrRad='6px'>
				<FlexDiv $width='180px'>
					<GenericP f_weight='900' color='#000' right_M='8'>{`${index + 1}.`}</GenericP>
					<div>
						<GenericP f_weight='900' color='#000' bottom_M='2'>{`${name}, ${age}${gender.name[0]}, ${nationality}`} </GenericP>
						<GenericP bottom_M='8' fsize='12px'>{emailId}</GenericP>
						{govtIdNo && <GenericP fsize='12px' f_weight='900'>{`${govtIdType.name}: ${govtIdNo}`}</GenericP>}
						<GenericP fsize='12px'>{`${berthPref.name}, ${meal.name} food`}</GenericP>
					</div>
				</FlexDiv>
				<EditButton className='edit_arrow' onClick={editPassengerDetails(passenger, index)}>
					<AngleArrow color='#FF664B' />
				</EditButton>
			</TravellerDetailsWrap>
		);
	};

	const cardViewProps = isMobile ? cardViewMobileProps : {};

	const numberOfPassengers = passengerDetails && passengerDetails.length ? `(${passengerDetails.length})` : '';
	return (
		<PassengerDetailsWrapper isMobile={isMobile}>
			<CardView
				{...cardViewProps}>
				<GenericP
					fsize='16px'
					f_weight='900'
					bottom_M='16'>
					Traveller {numberOfPassengers}
				</GenericP>
				{passengerDetails && passengerDetails.map((passenger, index) => isMobile ? mobileDetailsView(index, passenger) : detailView(index, passenger))}
				<AddTravellerWrapper align='center' bdrRad='6px' justify='flex-start'>
					<TrainIcon icon='icAdd' />
					<Link onClick={addTraveller}>
						ADD TRAVELLER
					</Link>
				</AddTravellerWrapper>
			</CardView>
			{showForm && <TravellersForm
				closeModal={closeForm}
				data={formData}
				deletePassenger={deletePassenger(editableIndex)}
				addNewPassenger={addNewPassenger}
			/>}
		</PassengerDetailsWrapper>
	);
}

export default PassengerDetails;
